export default "__VITE_ASSET__CS8hnr6C__"